module.exports = __webpack_public_path__ + "static/media/NoPhoto.ccb9f5f8.svg";